const colors = {
    mainBlue: "#2196F3",
    black: "#000000",
    green: "rgba(88, 183, 194, 0.9)",
    blackLight: "#A5AAB5",
    teacherTheme: "#58B7C2",
    white: "#FAFAFA",
    mainWhite: "#fff",
    lightBlue: "#DCE2F9;",
    darkBlue: "#3359DF;",
    grey01: "#E5E5E5",
    grey02: "#a7a7a7",
    grey03: "#F4F6FC",
    navLinkColorDefault: "#A2A3AB",
    borderColor: "#868E96",
    redError: "rgb(211, 47, 47)",
};

export { colors };